<template>
  <v-row class="d-flex" no-gutters>
    <v-col class="col-md-6 order-2 order-lg-0 col-lg-4 col-12 mb-2 pr-0 pr-md-2">
      <m-select
        :value="statuses"
        :clearable="true"
        :items="filterStatus"
        :multiple="true"
        :placeholder="$t('offer-manager.offers-list.lbl-filter-status')"
        :showSelectedCounter="true"
        data-cy="offerStatusFilter"
        @input="value => $emit('update:statuses', value)">
        <template v-slot:prepend-inner>
          <i class="icon-mapit icon-filter-status"></i>
        </template>
      </m-select>
    </v-col>

    <v-col class="col-md-6 order-2 order-lg-0 col-lg-4 col-12 d-flex align-center mb-2 pr-0 pr-md-2">
      <v-checkbox
        :input-value="showExpired"
        class="m-checkbox"
        :label="$t('offers.filters.expired-offers')"
        @change="value => $emit('update:showExpired', value)" />
    </v-col>

    <v-col class="col-md-6 order-2 order-lg-0 col-lg-4 col-12 mb-2 pr-0 pr-md-2">
      <m-text-field
        :value="text"
        :clearable="true"
        :placeholder="$t('offer-manager.offers-list.lbl-search')"
        data-cy="offerSearchFilter"
        @input="value => $emit('update:text', (value || '').trim())"
        @keydown="onTextKeydown"
        @keyup="onTextKeyup" />
    </v-col>
  </v-row>
</template>

<script lang="ts">
import {computed, defineComponent, PropType} from '@vue/composition-api'

import {Status} from '@/types/offers'

export default defineComponent({
  name: 'OffersFilters',
  model: {prop: 'text', event: 'update:text'},
  props: {
    statuses: {
      type: Array as PropType<Status[]>,
      default: () => [],
    },
    text: {
      type: String,
      default: '',
    },
    showExpired: {
      type: Boolean,
      default: false,
    },
  },
  setup(_, {root, emit}) {
    const filterStatus = computed(() =>
      Object.values(Status).map(status => ({
        text: root.$t(`offers.status.${status}`).toString(),
        value: status,
      })),
    )

    const MAX_HOLD_DURATION = 50
    const keyStopper = {value: false}
    const activeKeys: Record<string, number> = {}

    function onTextKeydown(e: KeyboardEvent) {
      if (!activeKeys[e.code] && e.code !== 'Backspace') {
        activeKeys[e.code] = Date.now()
      }
      if (keyStopper.value) {
        e.preventDefault()
        return
      }
      if (Date.now() - activeKeys[e.code] > MAX_HOLD_DURATION) {
        e.preventDefault()
        keyStopper.value = true
      }
      if (e.key === 'Enter') {
        e.preventDefault()
        emit('submit')
      }
    }

    function onTextKeyup({code}: KeyboardEvent) {
      keyStopper.value = false
      delete activeKeys[code]
    }

    return {filterStatus, onTextKeydown, onTextKeyup}
  },
})
</script>

<style scoped>
.m-checkbox {
  border: 1px solid #bbb;
  padding: 7px;
  border-radius: 4px;
  width: 100%;
  margin: 0;
}
</style>

<style global>
.m-checkbox .v-input__slot,
.m-checkbox .v-messages {
  min-height: 0;
  margin: 0;
}
</style>
